export default __webpack_public_path__ + "5a8c8fb8ed28692f6b8aaf46afcf2c27.png";